import React from "react";
import { useSelector } from "react-redux";
import * as Icons from "Components/Icons";
import { DropdownItem } from "Components/ReactstrapSlim";
import { SocialVisibilityIndicator } from "Components/SocialVisibilityIndicator";
import useMediaBreakpointDown from "Hooks/useMediaBreakpointDown";
import { IHeaderMenuCountersViewModel } from "Services/API/API";
import { UserSelectorModel, brandingSelector } from "Utils/selectors";
import { HeaderDropDownMenuResources } from "./HeaderDropDownMenuResources";
import { SocialVisibilityToggle } from "./SocialVisibilityToggle";

const supportUrl = "https://support.liquidspace.com";
interface HeaderMemberDropDownMenuProps {
   user: UserSelectorModel;
   headerMenuCounters: IHeaderMenuCountersViewModel;
   isEnterpriseManagment?: boolean;
}
export const HeaderMemberDropDownMenu: React.FC<HeaderMemberDropDownMenuProps> = ({ user, headerMenuCounters, isEnterpriseManagment }) => {
   const branding = useSelector(brandingSelector);
   const isMobile = useMediaBreakpointDown("sm");   
   return <>
      <DropdownItem text className="header-user-popup-header">
         <div className="header-avatar header-avatar-lg">
            {
               user.imageUrl
                  ? <img src={user.imageUrl} alt={user.fullName || undefined} />
                  : <Icons.User />
            }
            <SocialVisibilityIndicator className="social-visibility-indicator-avatar" />
         </div >
         <div className="header-user-info">
            <div className="h7 text-truncate">{user.fullName}</div>
            <div className="p1 text-truncate">
               {
                  branding?.name && !user.isEnterpriseAccountAdmin
                     ? branding.name
                     : user.email
               }
            </div>
         </div>
      </DropdownItem >
      {!!branding?.socialActivityEnabled && !isEnterpriseManagment && <>
         <DropdownItem divider />
         <DropdownItem toggle={false}>
            <SocialVisibilityToggle />
         </DropdownItem>
         <DropdownItem divider />
      </>}
      {
         branding
            ? branding.portalType == LSCommon.Enums.BrandedPortalType.Mobility3 && branding.portalEnabled && branding.url
               ? <>
                  <DropdownItem tag="a" href={branding.url}>
                     Dashboard
                  </DropdownItem>
                  {isMobile && branding.socialCollaborationPortalEnabled &&
                     <DropdownItem tag="a" href={`${branding.url}/social`}>
                        Team Connect
                     </DropdownItem>
                  }
                  {isMobile &&
                     <DropdownItem tag="a" href="/search">
                        Search
                     </DropdownItem>
                  }
                  {isMobile &&
                     <DropdownItem tag="a" href={`${branding.url}/collections`}>
                        Collections
                     </DropdownItem>
                  }
                  <DropdownItem tag="a" href={`${branding.url}/messages`}>
                     Messages
                     {
                        headerMenuCounters.newMessagesCount
                           ? <div className="header-counter header-user-popup-counter">{headerMenuCounters.newMessagesCount}</div>
                           : null
                     }
                  </DropdownItem>
                  <DropdownItem tag="a" href={`${branding.url}/reservations`}>
                     Reservations
                     {
                        headerMenuCounters.upcomingReservationsCount
                           ? <div className="header-counter header-user-popup-counter">{headerMenuCounters.upcomingReservationsCount}</div>
                           : null
                     }
                  </DropdownItem>
                  <DropdownItem tag="a" href={`${branding.url}/settings`}>
                     Settings
                  </DropdownItem>
                  <DropdownItem tag="a" href={`${branding.url}/help`}>
                     Help
                  </DropdownItem>
               </>
               : <>
                  {branding.portalEnabled && branding.url && <DropdownItem tag="a" href={branding.url}>
                     Portal
                  </DropdownItem>}
                  <DropdownItem tag="a" href="/my/messenger">
                     Messages
                     {
                        headerMenuCounters.newMessagesCount
                           ? <div className="header-counter header-user-popup-counter">{headerMenuCounters.newMessagesCount}</div>
                           : null
                     }
                  </DropdownItem>
                  <DropdownItem tag="a" href="/my/reservations">
                     Reservations
                     {
                        headerMenuCounters.upcomingReservationsCount
                           ? <div className="header-counter header-user-popup-counter">{headerMenuCounters.upcomingReservationsCount}</div>
                           : null
                     }
                  </DropdownItem>
                  {isMobile &&
                     <DropdownItem tag="a" href="/my/collections">
                        Collections
                     </DropdownItem>
                  }
                  <DropdownItem tag="a" href="/my/settings">
                     Settings
                  </DropdownItem>
                  <DropdownItem tag="a" href={`/zendesksso/process?return_to=${encodeURIComponent(supportUrl)}`} target="_blank">
                     Help
                  </DropdownItem>
               </> : <>
               <DropdownItem tag="a" href="/my/liquidspace">
                  My LiquidSpace
               </DropdownItem>
               <DropdownItem tag="a" href="/my/reservations">
                  Reservations
                  {
                     headerMenuCounters.upcomingReservationsCount
                        ? <div className="header-counter header-user-popup-counter">{headerMenuCounters.upcomingReservationsCount}</div>
                        : null
                  }
               </DropdownItem>
               <DropdownItem tag="a" href="/my/messenger">
                  Messages
                  {
                     headerMenuCounters.newMessagesCount
                        ? <div className="header-counter header-user-popup-counter">{headerMenuCounters.newMessagesCount}</div>
                        : null
                  }
               </DropdownItem>
               {isMobile &&
                  <DropdownItem tag="a" href="/my/collections">
                     Collections
                  </DropdownItem>
               }
               <DropdownItem tag="a" href="/my/settings">
                  Settings
               </DropdownItem>
               <DropdownItem tag="a" href={`/zendesksso/process?return_to=${encodeURIComponent(supportUrl)}`} target="_blank">
                  Help
               </DropdownItem>
            </>
      }
      <DropdownItem tag="a" href="/account/logoff">
         Log Out
      </DropdownItem>

      {
         branding
            ? null
            : <>
               <DropdownItem divider className="d-md-none" />
               <HeaderDropDownMenuResources isAuthenticated={user.isAuthenticated} />
               {/* <DropdownItem tag="a" href="/share-office-meeting-space" className="d-md-none">Become a Host</DropdownItem> */}
            </>
      }
   </>;
}
